import { Component, ElementRef, inject, NgZone, OnInit, signal, ViewChild } from '@angular/core';
import { PropertyService } from '../../services/property.service';
import { AuthService } from '../../auth/auth.service';
import { Toast } from '../utils/toast.component';
import {MatBadgeModule} from '@angular/material/badge';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { saveAs } from 'file-saver'; // Import file-saver
import { DocumentViewerComponent } from '../utils/document-viewer/document-viewer.component';
import { MatDialog } from '@angular/material/dialog';
import { response } from 'express';
import { log } from 'node:console';
import { ActivatedRoute } from '@angular/router';
import { FILE_FORMAT, ToastType } from '../../enums/config.enum';
import { SystemAdminService } from '../../services/system-admin.service';
import { ToastService } from '../../services/toast.service';
import { take } from 'rxjs/operators';


@Component({
  selector: 'app-document-upload',
  standalone: true,
  imports: [MatBadgeModule,Toast,CommonModule],
  templateUrl: './document-upload.component.html',
  styleUrl: './document-upload.component.scss'
})
export class DocumentUploadComponent implements OnInit{
  @ViewChild(Toast) toast!: Toast;
@ViewChild('scrollContainer') scrollContainer!: ElementRef;
  userId = signal<string>('');
  versionNo = signal<string>('');
  companyId = signal<string>('');
  branchId = signal<string>('');
  indicationId = signal<string>('');
  policyId = signal<string>('');
  quoteId = signal<string>('')
  tempQuoteId = signal<string>('');
  tempQuoteNumber = signal<string | null>('');
  selectedFile = signal<File | null>(null);
  selectedFiles = signal<File[]>([]);
  filesToUpload: File[] = [];
  showUploadButton = signal<boolean>(false);
  documentIds = signal<number[]>([]);
  isDragOver = signal<boolean>(false);
  uploadedDocumentCount = signal<number>(0);
  // selectedFiles = signal<File[]>([]);
  onUploadErrorMessage = signal<string | null>('');
  uploadedDocuments = signal<any[]>([]);
  uploadedDocumentIds = signal<number[]>([])
  showSupportingDocument = signal<boolean>(false);
  showDocumentList = signal<boolean>(false);
  showDocumentViewer = signal<boolean>(false);
  allowedDocExtensionList = signal<string[]>([]);
  allowedDocExtensionName = signal('');
  DocColorRed = signal<boolean>(false);
  DocColorGreen = signal<boolean>(false);
  maxAllowedUploadSize = signal<number>(2);
  safeDocumentUrl: SafeResourceUrl | undefined = undefined;
  authService = inject(AuthService);
  propertyService = inject(PropertyService);
  dialog = inject(MatDialog)
  route = inject(ActivatedRoute);
  toastService = inject(ToastService);
  systemAdminService = inject(SystemAdminService);
  ngZone = inject(NgZone);

  ngOnInit(): void {
    this.loadDocumentIdsfromSessionStorage();
    this.getAllowedDocumentExtension();
    this.route.params.subscribe(params => {
      const id = params['id'];
      if(id){
        this.getDocumentsFromEntities(id);
      }
    })
  }
   

  toogleDocumentList(value: boolean){
    this.showDocumentList.set(value);
  }
    
  // Drag Over Handler
  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragOver.set(true);  // Add the dragover class to the drop zone
  }

  // Drag Leave Handler
  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragOver.set(false);  // Remove the dragover class when dragging leaves the zone
  }

  // File Drop Handler
  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragOver.set(false);

    if (event.dataTransfer?.files) {
        for (let i = 0; i < event.dataTransfer.files.length; i++) {
            const file = event.dataTransfer.files[i];
            this.validateAndAddFile(file); // Use the helper function
        }
    }
}

onFileSelected(event: any) {
    const files: FileList = event.target.files;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      this.validateAndAddFile(file); // Use the helper function
      this.scrollToBottom()
    }
    event.target.value = ''; // Clear the input

}

validateAndAddFile(file: File) { // Helper function for validation and adding
    const allowedFileTypes = this.allowedDocExtensionList();
    const maxSizeInBytes = this.maxAllowedUploadSize() * 1024 * 1024; // 2MB

    if (!allowedFileTypes.includes(file.type)) {
        //this.onUploadErrorMessage.set(`Only ${this.allowedDocExtensionName()} files are allowed.`);
        this.toastService.addNotification({message: `Only ${this.allowedDocExtensionName()} files are allowed.`, type: ToastType.Error})
        return;
    }

    if (file.size > maxSizeInBytes) {
        //this.onUploadErrorMessage.set('File size must not exceed 2MB.');
        this.toastService.addNotification({message: `File size must not exceed ${this.maxAllowedUploadSize()}MB.`, type: ToastType.Error})
        return;
    }  

    this.selectedFiles.set([...this.selectedFiles(), file]);
    this.filesToUpload.push(file);
    this.showUploadButton.set(true);
    this.onUploadErrorMessage.set(null);
this.ngZone.onStable.pipe(take(1)).subscribe(() => {
    this.scrollToBottom();
  });}

scrollToBottom(): void {    
    this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
}
  getDetails(){
    const storageData = this.authService.getUserDetailsFromStorage();
    const tempQuoteId = sessionStorage.getItem('tempQuoteId');
    const tempQuoteNumber = sessionStorage.getItem('tempQuoteNumber');
    const versionNo = sessionStorage.getItem('versionNo');
    const userId = storageData?.userDetails?.userId;
    const companyId = storageData?.companyId;
    const branchId = storageData?.branchId;
    const indicationId = storageData?.indicationId;
    const policyId = storageData?.policyId;
    const quoteId = storageData?.quoteId;
    if (userId) {
      this.userId.set(String(userId));
      this.tempQuoteId.set(String(tempQuoteId));
      this.tempQuoteNumber.set(tempQuoteNumber);
      this.versionNo.set(String(versionNo));
      this.companyId.set(String(companyId));
      this.branchId.set(String(branchId));
      this.indicationId.set(String(indicationId));
      this.policyId.set(String(policyId))
      this.quoteId.set(String(quoteId));
    };
  }

  uploadMultipleFiles() {
    if (this.filesToUpload.length === 0) {
      return; // No files to upload
    }
    this.getDetails()
    const formData = new FormData();
    this.filesToUpload.forEach((file, index) => {
      formData.append('Documents', file, file.name); // Include filename
    });
    
    formData.append('userId',this.userId());
    formData.append('CompanyId',this.companyId());
    formData.append('BranchId',this.branchId());
    if(this.authService?.getUserDetailsFromStorage()?.isPolicyType){
      formData.append('PolicyId',this.policyId());
      formData.append('PolicyVersionNo',"1");
      formData.append('StepUpload','P');

    }
    else{
      if(this.isIndicationType()){
      if(this.authService?.getUserDetailsFromStorage()?.indicationId){ // indication messages
        formData.append('IndicationId',this.indicationId());
          formData.append('IndicationVersionNo',this.versionNo());
          formData.append('StepUpload','I');
        }else{
        formData.append('TempId',this.tempQuoteId());
        formData.append('StepUpload','T');
        }
    }else{
      formData.append('QuoteId',this.quoteId());
      formData.append('QuoteVersionNo',this.versionNo());
      formData.append('StepUpload','Q');
    }
  }
    this.uploadDocumentByTempQuoteId(formData)
  };

  uploadDocumentByTempQuoteId(formData: FormData) {
    this.propertyService.uploadDocument(formData).subscribe({
      next: (response: any) => {
        if (response && response.documentIds && Array.isArray(response.documentIds)) {
          this.showToast("Document uploaded successfully", 'success');
  
          // Store in session storage
          this.updateDocumentIdsinSessionStorage(response.documentIds);

          const storedDocumentIds = this.getDocumentIdsfromSessionStorage();
          // Fetch uploaded documents
          if(this.isUwAdmin()){
            this.route.params.subscribe(params => {
              const id = params['id'];
              if(id){
                this.getDocumentsFromEntities(id);
              }
            })
          }else{
          this.getUploadedDocuments(storedDocumentIds);
          }
          this.showSupportingDocument.set(true);
          // this.uploadedDocumentCount.set(this.uploadedDocuments().length);
          this.selectedFiles.set([]); // Clear selected files after successful upload
          this.filesToUpload = []; // Clear files to upload
          this.showUploadButton.set(false); // Hide upload button        
          } else {
          this.showToast("Document upload failed. Invalid server response.", 'error');
        }
      },
      error: (error) => {
        this.selectedFiles.set([]); // Clear selected files after successful upload
        this.filesToUpload = []; // Clear files to upload
        this.showUploadButton.set(false); // Hide upload button 
        this.toastService.addNotification({message: "System error. Failed to save data. Please exit and contact help@AbacusAU.com.", type: ToastType.Error}); // error notification
      }
    });
  }

  uploadSingleFile(file: File) {
  this.getDetails();
  const formData = new FormData();
  formData.append('Documents', file, file.name);

  formData.append('userId', this.userId());
  formData.append('CompanyId', this.companyId());
  formData.append('BranchId', this.branchId());

  if (this.authService?.getUserDetailsFromStorage()?.isPolicyType) {
    formData.append('PolicyId', this.policyId());
    formData.append('PolicyVersionNo', "1");
    formData.append('StepUpload', 'P');
  } else if (this.isIndicationType()) {
    const indicationId = this.authService?.getUserDetailsFromStorage()?.indicationId;
    if (indicationId) {
      formData.append('IndicationId', this.indicationId());
      formData.append('IndicationVersionNo', this.versionNo());
      formData.append('StepUpload', 'I');
    } else {
      formData.append('TempId', this.tempQuoteId());
      formData.append('StepUpload', 'T');
    }
  } else {
    formData.append('QuoteId', this.quoteId());
    formData.append('QuoteVersionNo', this.versionNo());
    formData.append('StepUpload', 'Q');
  }

  this.propertyService.uploadDocument(formData).subscribe({
    next: (response: any) => {
      this.showToast("Document uploaded successfully", 'success');
      this.updateDocumentIdsinSessionStorage(response.documentIds);
      const storedIds = this.getDocumentIdsfromSessionStorage();
      if (this.isUwAdmin()) {
        this.route.params.subscribe(params => {
          const id = params['id'];
          if (id) this.getDocumentsFromEntities(id);
        });
      } else {
        this.getUploadedDocuments(storedIds);
      }
  this.showSupportingDocument.set(true);
  this.showDocumentList.set(true)
      // Remove this file from selected
      this.selectedFiles.set(this.selectedFiles().filter(f => f !== file));
      this.filesToUpload = this.filesToUpload.filter(f => f !== file);
      
    },
    error: () => {
      this.toastService.addNotification({
        message: "System error. Failed to save data. Please exit and contact help@AbacusAU.com.",
        type: ToastType.Error
      });
    }
  });
}

removeFile(index: number) {
  const updated = [...this.selectedFiles()];
  updated.splice(index, 1);
  this.selectedFiles.set(updated);
  this.filesToUpload.splice(index, 1);
  if (updated.length === 0) {
    this.showUploadButton.set(false); // Hide bulk upload button if needed
  }
}


    isUwAdmin(): boolean {
    const role = sessionStorage.getItem('role')
    return role === "2";
  }

  loadDocumentIdsfromSessionStorage(): void {
    const storedIds = sessionStorage.getItem('documentIds');
    if (storedIds) {
      try {
        const documentIds: number[] = JSON.parse(storedIds);
        if (Array.isArray(documentIds) && documentIds.length > 0) {
          this.uploadedDocumentIds.set(documentIds); // Initialize with stored IDs
          this.showSupportingDocument.set(true);         
          if(this.isUwAdmin()){
            this.route.params.subscribe(params => {
              const id = params['id'];
              if(id){
                this.getDocumentsFromEntities(id);
              }
            })
          }else{
             this.getUploadedDocuments(documentIds); // Fetch existing documents
          }
        }
      } catch (error) {
        sessionStorage.removeItem('documentIds'); // Clear invalid data
      }
    }
  }

  updateDocumentIdsinSessionStorage(newDocumentIds: number[]): void {
    // Retrieve existing document IDs from local storage
    const storedIds = sessionStorage.getItem('documentIds');
    const existingDocumentIds: number[] = storedIds ? JSON.parse(storedIds) : [];
  
    // Merge new IDs, ensuring no duplicates
    const updatedDocumentIds = Array.from(new Set([...existingDocumentIds, ...newDocumentIds]));
  
    // Save back to local storage
    sessionStorage.setItem('documentIds', JSON.stringify(updatedDocumentIds));
  
    // Update signal 
    this.uploadedDocumentIds.set(updatedDocumentIds);
  }

  getDocumentIdsfromSessionStorage(): number[] {
    const storedIds = sessionStorage.getItem('documentIds');
    return storedIds ? JSON.parse(storedIds) : [];
  }
  

  // Save document IDs to session storage
  saveDocumentIdsToSessionStorage(documentIds: number[]): void {
    sessionStorage.setItem('documentIds', JSON.stringify(documentIds));
  }

  constructDocumentsPayload(id: number): any {
    if (this.authService?.getUserDetailsFromStorage()?.isPolicyType) {
      return { quoteId: null, policyId: id, indicationId: null };
    } else if (this.isIndicationType()) {
      return { quoteId: null, policyId: null, indicationId: id };
    } else {
      return { quoteId: id, policyId: null, indicationId: null };
    }
  }

  getAllowedDocumentExtension(){
    this.systemAdminService.getFileConfig().subscribe({
      next: (response: any) => {
        if(response){
          const responseData = response[0];
          const allowedExtensions = responseData?.docAllowedExtensions.split(",");
          this.allowedDocExtensionName.set(responseData?.docAllowedExtensions); // supported file
          this.maxAllowedUploadSize.set(Number(responseData?.docMaxFileSize)); // max file
          if(allowedExtensions?.length > 0){
            const extensionList = allowedExtensions.map((ext: string) => FILE_FORMAT[ext])
            this.allowedDocExtensionList.set(extensionList);
          }
        }
      },
      error: (error: any) => {
        const defaultExtension = ['application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
        this.allowedDocExtensionName.set('.pdf, .docx');
        this.allowedDocExtensionList.set(defaultExtension);
      }
    })
  }
  
 

  getDocumentsFromEntities(id: number) {
    const payload = this.constructDocumentsPayload(id);
  
    this.propertyService.getDocumentsByEntities(payload).subscribe({
      next: (response: any) => {
        if (Array.isArray(response)) {
          this.showSupportingDocument.set(true);
          if(this.isUwAdmin()){           
            this.uploadedDocuments.set(response);
          }else{
            const filteredResponse = response.filter(doc => doc.isDeleted === 0);
            this.uploadedDocuments.set(filteredResponse)
            this.DocColorGreen.set(true)
          }
          this.uploadedDocumentCount.set(this.uploadedDocuments().length);  
          // Extract document IDs from response and update local storage
          const documentIds = response.map(doc => doc.documentId);
          this.updateDocumentIdsinSessionStorage(documentIds);
        } else {
        }
      },
      error: (error) => {
      }
    });
  }
  
  

  
  getUploadedDocuments(documentIds: number[]) {
    this.propertyService.getDocuments(documentIds).subscribe({ // Call the service method
      next: (response: any) => {
        // this.uploadedDocuments.set([...this.uploadedDocuments(), ...response]);
         if(this.isUwAdmin()){
            this.uploadedDocuments.set(response);
          }else{
            const filteredResponse = response.filter((doc:any) => doc.isDeleted === 0);
            this.uploadedDocuments.set(filteredResponse)
          }
        this.uploadedDocumentCount.set(this.uploadedDocuments().length);
        // this.showDocumentList.set(true);
      },
      error: (error) => {
       
      }
    });
  }

  // viewDocument(documentId: number): SafeUrl {
  //   return this.propertyService.getViewDocumentUrl(documentId); // Call service method
  // }

  viewDocument(documentId: number): SafeUrl {
    return this.propertyService.getViewDocumentUrls(documentId); // Call service method
  }

  openDocument(documentId: number): void {
    const documentUrl = this.propertyService.getViewDocumentUrl(documentId);
    
    this.dialog.open(DocumentViewerComponent, {
      width: '80%',
      height: '80%',
      data: { documentUrl }
    });
  }

  deleteDocument(documentId: number) {
    this.propertyService.deleteDocument(documentId).subscribe({ // Call the service method
      next: (response: any) => {
        this.showToast("Document deleted successfully", 'success');
        const currentDocuments = this.uploadedDocuments();
        const updatedDocuments = currentDocuments.filter(doc => doc.documentId !== documentId);
        this.uploadedDocuments.set(updatedDocuments);
        this.uploadedDocumentCount.set(updatedDocuments.length);
        if (updatedDocuments.length === 0) {
          this.showDocumentList.set(false);
          this.showSupportingDocument.set(false);
        }
      },
      error: (error) => {
        this.showToast("Failed to delete document.", 'error');
      }
    });
  }

  downloadDocument(documentId: number, documentName: string) {
    this.propertyService.downloadDocument(documentId).subscribe(blob => {
      const fileName = `${documentName}.pdf`; // Or determine file extension dynamically
      saveAs(blob, documentName);
    }, error => {
      this.showToast("Error downloading document.", 'error'); // Show an error toast
    });
  }

  downloadAndOpenDocument(documentId: number, documentName: string) {
    this.propertyService.downloadDocument(documentId).subscribe(blob => {
      const fileName = `${documentName}.pdf`; //determine file extension dynamically

      //Create a Blob URL
      const blobUrl = URL.createObjectURL(blob);

      //Create a new window/tab
      const newWindow = window.open('', '_blank');

      if (newWindow) { // Check if the popup was not blocked
        //Create an iframe
        const iframe = newWindow.document.createElement('iframe');
        iframe.src = blobUrl;
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.style.border = 'none'; 

        //Append the iframe to the new window's document
        newWindow.document.body.appendChild(iframe);

        // Set the title of the new tab
        newWindow.document.title = documentName;

        //Revoke the Blob URL when the iframe is unloaded (important for memory management)
        iframe.onload = () => {
          URL.revokeObjectURL(blobUrl);
        };

        newWindow.addEventListener('beforeunload', () => {
          URL.revokeObjectURL(blobUrl);
        });

      } else {
        // Handle popup block - inform the user
        alert('Popup blocked! Please allow popups for this site to view the document.');
        URL.revokeObjectURL(blobUrl); //revoke even if popup blocked
      }


    }, error => {
      this.showToast("Error downloading document.", 'error'); // Show an error toast
    });
  }

  addAnotherDocument() {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  showToast(message: string, type: string){
    this.toast.message = message
    this.toast.type = type;
    this.toast.show();
  }
  isIndicationType(): boolean {
    const quoteType = this.authService.getUserDetailsFromStorage().quoteType;
    return quoteType === "indication";
  }
}